export default __webpack_public_path__ + "static/media/vv_logo_fi.b76e7776.png";